module.exports = __webpack_public_path__ + "static/media/ChangeAmount.68455ea0.scss";


//////////////////
// WEBPACK FOOTER
// ./src/modules/modals/change-amount/ChangeAmount.scss
// module id = 954
// module chunks = 0